import { API } from "../../../config";
import CONSTANTS from "../../../constants/constants";
import AxiosUtils from "../../../utils/AxiosUtils";
import { serverAPIPath ,mockAPIPath} from "../config/apiPath";


class OTPService {

    private payload: object;
    private isHitDummyURL: boolean;

    constructor(payload = {}, isHitDummyURL = false) {
        this.payload = payload;
        this.isHitDummyURL = isHitDummyURL;
    }

    async generate(isDemoUser?:boolean){
        const response = this.isHitDummyURL && API.HIT_DUMMY_URL ? 
            await new AxiosUtils(`${mockAPIPath.GENERATE_OTP}`, this.payload).getNew() :
            await new AxiosUtils(`${API.BASE_URL}${serverAPIPath.GENERATE_OTP}`, this.payload,{"demo-user": isDemoUser ?  CONSTANTS.DEMO_USER_CONSTANTS : "" }).post();
        let isOtpSent: string;
        if(response?.data?.success==true) {
            isOtpSent = response?.data?.message;
            return isOtpSent;
        }
        else if(response?.success == false)
        {   
            throw new Error(response?.message);        
        }else{
            throw new Error(response);
        } 
    }

    async verify(isDemoUser?:boolean){
        const response = this.isHitDummyURL && API.HIT_DUMMY_URL ?
            await new AxiosUtils(mockAPIPath.VERIFY_OTP, this.payload).getNew() : 
            await new AxiosUtils(`${API.BASE_URL}${serverAPIPath.VERIFY_OTP}`, this.payload,{"demo-user": isDemoUser ?  CONSTANTS.DEMO_USER_CONSTANTS : "" }).post();
        if(response?.data?.success===true) {
            return response?.data?.data;
        }
        else if(response?.success == false)
        {   
            throw new Error(response?.message);        
        }else{
            throw new Error(response);
        } 
    }
}

export default OTPService;